import { useNavigate } from 'react-router-dom';
import DashboardLayout from '@/components/layout/DashboardLayout';
import YummyDeclaration from '@/components/YummyDeclaration';

const YummyDeclarationPage = () => {
  const navigate = useNavigate();

  return (
    <DashboardLayout>
      <div className="max-w-2xl mx-auto py-8">
        <YummyDeclaration 
          onComplete={() => {
            navigate('/dashboard');
          }}
        />
      </div>
    </DashboardLayout>
  );
};

export default YummyDeclarationPage;
